import React, { useEffect, useState, useRef, useCallback } from "react";
import ReportHeading from "../../Components/ReportHeadings/ReportHeadings";
import {
  getfundRequestReportService,
  getpaySlipPreviewService,
  handleFormSTatusService,
} from "../../../services/walletservice";
import Loader from "../../../components/Loader/Loader";
import Button from "../../Components/ButtonComponent/Button";
import { showErrorToast, showSuccessToast } from "../../../utils/toastUtils";
import ImageSketlton from "../../../components/Loader/ImageSkelton";
import {
  FaInbox,
  FaUsers,
  FaCheckCircle,
  FaTimesCircle,
  FaClock,
  FaRupeeSign,
  FaCheck,
  FaTimes,
} from "react-icons/fa";
import FundApprovePopup from "../../../components/Dialog/FundApprovePopup";
import {
  Banknote,
  Eye,
  Hash,
  Loader2,
  PiggyBank,
  QrCode,
  ReceiptCent,
  User,
  ViewIcon,
  Wallet,
  X,
} from "lucide-react";
import PaymentSlipModal from "../../../components/fund/PaymentSlip";
import ImageSlipModal from "../../../components/fund/PaymentSlipImg";
import { ToWords } from "to-words";

const FundApprove2 = () => {
  const [fundRequestReport, setFundRequestReport] = useState([]);
  const [paginationData, setPaginationData] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [totaldata, setTotalData] = useState(50);
  const [isLoading, setIsLoading] = useState(false);
  const [approvePopUp, setApprovePopUp] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState("");
  const [amount, setAmount] = useState();
  const [selectedName, setSelectedName] = useState("");
  const [paySlip, setPaySlip] = useState("");
  const [filename, setFileName] = useState("");
  const [isImagePreview, setIsImagePreview] = useState(false);
  const [remarks, setRemarks] = useState("");
  const [selectedFundId, setSelectedFundId] = useState("");
  const [imagePreviewClicked, setImagePreviewClicked] = useState(false);
  const [showSlip, setShowSlip] = useState("none");
  const [slipDetailsForUpi, setSlipdetailsForUpi] = useState(null);
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [fundApproveLoading, setFundApproveLoading] = useState({
    type: "",
    loadingStatus: false,
  });

  const toWords = new ToWords({
    localeCode: "en-IN",
  });
  const colorClasses = {
    blue: {
      card: "bg-blue-700 border-blue-200 hover:border-blue-400 hover:bg-blue-50",
      icon: "bg-blue-100 group-hover:bg-blue-200",
      label: "text-white group-hover:text-blue-50",
      value: "text-white/70 group-hover:text-blue-50",
    },
    green: {
      card: "bg-green-700 border-green-200 hover:border-green-400 hover:bg-green-50",
      icon: "bg-green-100 group-hover:bg-green-200",
      label: "text-white group-hover:text-green-50",
      value: "text-white/70 group-hover:text-green-50",
    },
    red: {
      card: "bg-red-700 border-red-200 hover:border-red-400 hover:bg-red-50",
      icon: "bg-red-100 group-hover:bg-red-200",
      label: "text-white group-hover:text-red-50",
      value: "text-white/70 group-hover:text-red-50",
    },
    yellow: {
      card: "bg-yellow-700 border-yellow-200 hover:border-yellow-400 hover:bg-yellow-50",
      icon: "bg-yellow-100 group-hover:bg-yellow-200",
      label: "text-white group-hover:text-yellow-50",
      value: "text-white/70 group-hover:text-yellow-50",
    },
    indigo: {
      card: "bg-indigo-700 border-indigo-200 hover:border-indigo-400 hover:bg-indigo-50",
      icon: "bg-indigo-100 group-hover:bg-indigo-200",
      label: "text-white group-hover:text-indigo-50",
      value: "text-white/70 group-hover:text-indigo-50",
    },
    orange: {
      card: "bg-orange-700 border-orange-200 hover:border-orange-400 hover:bg-orange-50",
      icon: "bg-orange-100 group-hover:bg-orange-200",
      label: "text-white group-hover:text-orange-50",
      value: "text-white/70 group-hover:text-orange-50",
    },
  };

  // Filter states
  const [filters, setFilters] = useState({
    from_date: "",
    to_date: "",
    status: "",
    user_id: "",
  });

  // Debounce timer ref
  const debounceTimerRef = useRef(null);

  async function getPaySlipPreview() {
    setIsImagePreview(true);
    const response = await getpaySlipPreviewService(filename);
    setPaySlip(response.dataUri);
    setIsImagePreview(false);
  }

  async function getFundRequestReport(page = 1) {
    try {
      setIsLoading(true);
      const filterData = {
        total_data: totaldata,
        from_date: filters.from_date || null,
        to_date: filters.to_date || null,
        status: filters.status || null,
        user_id: filters.user_id || null,
      };

      const response = await getfundRequestReportService(filterData, page);
      setIsLoading(false);
      setFundRequestReport(response?.data?.data || {});
      setPaginationData(response?.data?.pagination);
      setCurrentPage(page);
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  }

  async function handleFundStatus(statuus) {
    setFundApproveLoading({ type: statuus, loadingStatus: true });
    try {
      const response = await handleFormSTatusService(
        selectedFundId,
        statuus,
        remarks,
      );

      if (response.status.code === 200) {
        showSuccessToast(response.message || response?.data?.message || response?.status?.message);
        setFileName("");
        setPaySlip("");
        setSelectedFundId("");
        setRemarks("");
        setApprovePopUp(false);
        getFundRequestReport(currentPage);
      } else {
        const err = response?.errors || response?.data?.errors;
        Object.values(err).forEach((messages) => {
          messages.forEach((message) => showErrorToast(message));
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setFundApproveLoading({ type: "", loadingStatus: false });
    }
  }

  // Handle filter changes
  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // Handle search button click
  const handleSearch = () => {
    setCurrentPage(1);
    getFundRequestReport(1);
  };

  // Handle reset filters
  const handleResetFilters = () => {
    setFilters({
      from_date: "",
      to_date: "",
      status: "",
      user_id: "",
    });
    setCurrentPage(1);
    setTotalData(10);
    // Clear debounce timer
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }
  };

  // Debounced search for user_id (triggers after 3 characters)
  useEffect(() => {
    // Clear existing timer
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }

    // Only trigger search if user_id has 3 or more characters
    if (filters.user_id.length === 8) {
      debounceTimerRef.current = setTimeout(() => {
        setCurrentPage(1);
        getFundRequestReport(1);
      }, 1000); // 500ms delay
    } else if (filters.user_id.length === 0) {
      // If user clears the input, fetch all records
      debounceTimerRef.current = setTimeout(() => {
        setCurrentPage(1);
        getFundRequestReport(1);
      }, 1000);
    }

    // Cleanup function
    return () => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
  }, [filters.user_id]);

  // Auto-search when status changes
  useEffect(() => {
    setCurrentPage(1);
    getFundRequestReport(1);
  }, [filters.status]);

  // Auto-search when date filters change
  // useEffect(() => {
  //   if (filters.from_date || filters.to_date) {
  //     setCurrentPage(1);
  //     getFundRequestReport(1);
  //   }
  // }, [filters.from_date, filters.to_date]);

  // Pagination handlers
  const handlePreviousPage = () => {
    if (currentPage > 1) {
      getFundRequestReport(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (paginationData?.next_page_url) {
      getFundRequestReport(currentPage + 1);
    }
  };

  const handlePageClick = (pageNumber) => {
    getFundRequestReport(pageNumber);
  };

  // Generate page numbers for pagination
  const generatePageNumbers = () => {
    const totalPages = paginationData?.last_page || 1;
    const pages = [];
    const maxPagesToShow = 10;

    if (totalPages <= maxPagesToShow) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 5; i++) {
          pages.push(i);
        }
        pages.push("...");
        pages.push(totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(1);
        pages.push("...");
        for (let i = totalPages - 4; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        pages.push(1);
        pages.push("...");
        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
          pages.push(i);
        }
        pages.push("...");
        pages.push(totalPages);
      }
    }
    return pages;
  };

  useEffect(() => {
    if ((approvePopUp && filename) || showSlip === "online") {
      getPaySlipPreview();
    }
  }, [approvePopUp, filename, showSlip]);

  useEffect(() => {
    getFundRequestReport(1);
  }, [totaldata]);

  function getTotalFundDataCountByType(typesName) {
    if (!fundRequestReport || fundRequestReport.length === 0) {
      return 0;
    }
    const filteredReports = fundRequestReport?.filter(
      (curr) => curr.status && curr.status.value === typesName,
    );
    return filteredReports.length;
  }

  function getTotalFundDataAmountByType(typesName) {
    if (!fundRequestReport || fundRequestReport.length === 0) {
      return 0;
    }
    const totalAmount = fundRequestReport.reduce((acc, curr) => {
      if (typesName === "") {
        return acc + (parseFloat(curr.amount) || 0);
      }
      if (curr.status && curr.status.value === typesName) {
        return acc + (parseFloat(curr.amount) || 0);
      }
      return acc;
    }, 0);
    return totalAmount;
  }

  useEffect(() => {
    console.log("clicked", imagePreviewClicked);
  }, [imagePreviewClicked]);

  return (
    <div className="p-4 mt-6 bg-white overflow-hidden">
      {isLoading && <Loader />}

      <div className="flex justify-center mb-2">
        <ReportHeading name="Fund Approve" />
      </div>

      {/* Compact Fund Summary Cards */}
      <div className="grid grid-cols-2 sm:grid-cols-8 gap-1 overflow-x-auto pb-2 -mx-2 px-2">
        {[
          {
            label: "Total Requests",
            value: fundRequestReport?.length || 0,
            icon: <FaUsers className="w-4 h-4" />,
            color: "blue",
          },
          {
            label: "Approved",
            value: getTotalFundDataCountByType("approved"),
            icon: <FaCheckCircle className="w-4 h-4" />,
            color: "green",
          },
          {
            label: "Rejected",
            value: getTotalFundDataCountByType("rejected"),
            icon: <FaTimesCircle className="w-4 h-4" />,
            color: "red",
          },
          {
            label: "Pending",
            value: getTotalFundDataCountByType("pending"),
            icon: <FaClock className="w-4 h-4" />,
            color: "yellow",
          },
          {
            label: "Total Amount",
            value: "₹" + getTotalFundDataAmountByType(""),
            icon: <FaRupeeSign className="w-4 h-4" />,
            color: "indigo",
          },
          {
            label: "Approved Amt",
            value: "₹" + getTotalFundDataAmountByType("approved"),
            icon: <FaCheck className="w-4 h-4" />,
            color: "green",
          },
          {
            label: "Rejected Amt",
            value: "₹" + getTotalFundDataAmountByType("rejected"),
            icon: <FaTimes className="w-4 h-4" />,
            color: "yellow",
          },
          {
            label: "Pending Amt",
            value: "₹" + getTotalFundDataAmountByType("pending"),
            icon: <FaClock className="w-4 h-4" />,
            color: "orange",
          },
        ].map((box, index) => {
          const colors = colorClasses[box.color];
          return (
            <div
              key={index}
              className={`group backdrop-blur-sm border p-3 rounded-xl shadow-sm hover:shadow-lg transition-all duration-200 min-w-[85px] h-20 flex flex-col justify-between ${colors.card}`}
            >
              <div className="flex items-center gap-2 mb-1">
                <div className={`p-1.5 rounded-lg ${colors.icon}`}>
                  {box.icon}
                </div>

                <span
                  className={`text-xs font-semibold truncate ${colors.label}`}
                >
                  {box.label}
                </span>
              </div>

              <p className={`text-lg font-bold truncate ${colors.value}`}>
                {box.value}
              </p>
            </div>
          );
        })}
      </div>

      {/* Filter Section */}
      <div className="mt-2 bg-gray-50 p-2 rounded-md border">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2">
          {/* From Date */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              From Date
            </label>
            <input
              type="date"
              value={filters.from_date}
              onChange={(e) => handleFilterChange("from_date", e.target.value)}
              className="border border-gray-300 p-1 rounded-md w-full focus:ring-2 focus:ring-blue-500 focus:outline-none"
            />
          </div>

          {/* To Date */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              To Date
            </label>
            <input
              type="date"
              value={filters.to_date}
              onChange={(e) => handleFilterChange("to_date", e.target.value)}
              className="border border-gray-300 p-1 rounded-md w-full focus:ring-2 focus:ring-blue-500 focus:outline-none"
            />
          </div>

          {/* Status Filter - Auto Search */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Status
            </label>
            <select
              value={filters.status}
              onChange={(e) => handleFilterChange("status", e.target.value)}
              className="border border-gray-300 p-1 rounded-md w-full focus:ring-2 focus:ring-blue-500 focus:outline-none"
            >
              <option value="">All Status</option>
              <option value="pending">Pending</option>
              <option value="approved">Approved</option>
              <option value="rejected">Rejected</option>
            </select>
          </div>

          {/* User ID Search - Debounced Auto Search */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              User ID
            </label>
            <input
              type="text"
              value={filters.user_id}
              onChange={(e) =>
                handleFilterChange("user_id", e.target.value.toUpperCase())
              }
              placeholder="EX: APID***"
              className="border border-gray-300 p-1 rounded-md w-full uppercase focus:ring-2 focus:ring-blue-500 focus:outline-none"
            />
            {filters.user_id.length > 0 && filters.user_id.length < 3 && (
              <p className="text-xs text-orange-500 mt-1">
                Type at least 3 characters to search
              </p>
            )}
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex justify-center gap-3 mt-2">
          <button
            onClick={handleSearch}
            className="bg-blue-900 text-white px-6 py-2 rounded-md hover:bg-blue-800 transition"
          >
            Manual Search
          </button>
          <button
            onClick={handleResetFilters}
            className="bg-gray-500 text-white px-6 py-2 rounded-md hover:bg-gray-600 transition"
          >
            Reset All Filters
          </button>
        </div>

        {/* Search Status Indicator */}
        {/* {isLoading && (
          <div className="mt-3 text-sm text-blue-600 flex items-center gap-2">
            <span className="animate-spin">⏳</span> Searching...
          </div>
        )} */}
      </div>

      {/* Records Per Page */}
      <div className="mt-2 flex items-center gap-4">
        <label className="text-sm font-medium text-gray-700">
          Records per page:
        </label>
        <select
          className="border border-gray-300 p-2 rounded-md focus:ring-2 focus:ring-blue-500 focus:outline-none"
          value={totaldata}
          onChange={(e) => {
            setTotalData(e.target.value);
            setCurrentPage(1);
          }}
        >
          <option value="10">10</option>
          <option value="25">25</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>
        {paginationData?.total > 0 && (
          <span className="text-sm text-gray-600">
            Showing {paginationData?.from || 0} to {paginationData?.to || 0} of{" "}
            {paginationData?.total || 0} entries
          </span>
        )}
      </div>

      {/* Popup Modal */}
      <FundApprovePopup
        onClose={() => {
          setFileName("");
          setPaySlip("");
          setApprovePopUp(false);
          setRemarks("");
        }}
        visible={approvePopUp}
        title="Approve Funds"
        className="!max-h-[80vh] w-full overflow-y-auto overflow-x-hidden p-2 sm:p-4"
      >
        <div className="flex flex-col gap-6">
          {/* User Details Card */}
          <div className="w-full  bg-white p-5 rounded-2xl border border-gray-100 shadow-sm flex flex-col gap-4">
            {/* User ID Row */}
            <div className="flex items-center justify-between gap-4">
              <div className="flex items-center gap-2 text-gray-500">
                <Hash className="w-4 h-4" strokeWidth={2.5} />
                <span className="text-xs font-semibold uppercase tracking-wider">
                  User ID
                </span>
              </div>
              <span className="text-sm font-medium text-gray-700 bg-gray-50 px-2.5 py-1 rounded-md border border-gray-100">
                {selectedUserId}
              </span>
            </div>

            {/* User Name Row */}
            <div className="flex items-center justify-between gap-4">
              <div className="flex items-center gap-2 text-gray-500">
                <User className="w-4 h-4" strokeWidth={2.5} />
                <span className="text-xs font-semibold uppercase tracking-wider">
                  User Name
                </span>
              </div>
              <span className="text-sm font-medium text-gray-900">
                {selectedName}
              </span>
            </div>

            {/* Amount Row (Highlighted) */}
            <div className="flex items-center justify-between gap-4 pt-3 border-t border-gray-100">
              <div className="flex items-center gap-2 text-gray-500">
                <Wallet className="w-4 h-4" strokeWidth={2.5} />

                <span className="text-xs font-semibold uppercase tracking-wider">
                  Amount
                </span>
              </div>

              <div className="text-right">
                <span className="text-sm font-bold text-emerald-700 bg-emerald-50 px-3 py-1.5 rounded-lg border border-emerald-100">
                  ₹{amount}
                </span>

                <div className="mt-2 text-sm  text-emerald-600">
                  {amount &&
                    toWords.convert(Number(amount), {
                      currency: true,
                    })}
                </div>
              </div>
            </div>
          </div>
          {/* Payment Slip Section */}
          <div className="flex flex-col items-center gap-2">
            <h3 className="text-2xl  font-semibold text-gray-800">
              <span className="flex items-center gap-2">
                {" "}
                <ReceiptCent /> Payment Receipt
              </span>{" "}
              <p className="text-gray-500 text-xs justify-center flex items-center gap-1">
                {" "}
                <Eye size={14} /> Click To Preview
              </p>
            </h3>
            <div className="relative w-36 h-36 sm:h-34 bg-gray-50 border border-gray-200 rounded-xl overflow-hidden flex items-center justify-center">
              {isImagePreview ? (
                <ImageSketlton />
              ) : (
                <button onClick={() => setImagePreviewClicked(true)}>
                  <img
                    src={paySlip}
                    alt="Payment Slip"
                    className="max-h-full max-w-full object-contain p-2"
                  />
                </button>
              )}
            </div>
          </div>

          {/* Remarks Section */}
          <div className="flex flex-col gap-2">
            <label
              htmlFor="remarks"
              className="text-sm font-semibold text-gray-800"
            >
              Remarks
            </label>
            <textarea
              name="remarks"
              id="remarks"
              rows={3}
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
              className="w-full border border-gray-300 rounded-xl p-3 text-sm text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-shadow resize-none"
              placeholder="Add any internal notes or reasons for rejection..."
            />
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col-reverse sm:flex-row justify-end gap-3 pt-4 border-t border-gray-100 mt-2">
            {/* <Button
              type="button"
              disabled={!remarks || (fundApproveLoading?.type === "rejected" && fundApproveLoading.loadingStatus)}
              onClick={() => handleFundStatus("rejected")}
              text="Reject"
              className="w-full sm:w-auto px-5 py-2.5 disabled:opacity-50 disabled:cursor-not-allowed bg-white border border-red-200 text-red-600 font-semibold rounded-lg hover:bg-red-50 focus:outline-none focus:ring-4 focus:ring-red-100 transition-all"
            /> */}

            <button
              type="button"
              disabled={
                !remarks ||
                (fundApproveLoading?.type === "rejected" &&
                  fundApproveLoading.loadingStatus)
              }
              onClick={() => handleFundStatus("rejected")}
              className="w-full sm:w-auto px-5 py-2.5 disabled:opacity-50 disabled:cursor-not-allowed bg-white border border-red-200 text-red-600 font-semibold rounded-lg hover:bg-red-50 focus:outline-none flex justify-center items-center focus:ring-4 focus:ring-red-100 transition-all"
            >
              {fundApproveLoading?.type === "rejected" &&
              fundApproveLoading.loadingStatus ? (
                <>
                  <Loader2 className="animate-spin text-light" />
                </>
              ) : (
                "Reject"
              )}
            </button>
            {/* <Button
              type="button"
              disabled={!remarks}
              onClick={() => handleFundStatus("approved")}
              text="Approve Funds"
              className="w-full sm:w-auto px-5 py-2.5 disabled:opacity-50 disabled:cursor-not-allowed bg-emerald-600 text-white font-semibold rounded-lg hover:bg-emerald-700 focus:outline-none focus:ring-4 focus:ring-emerald-200 transition-all shadow-sm"
            /> */}
            <button
              type="button"
              disabled={
                !remarks ||
                (fundApproveLoading?.type === "approved" &&
                  fundApproveLoading.loadingStatus)
              }
              onClick={() => handleFundStatus("approved")}
              text="Approve Funds"
              className="w-full sm:w-auto px-5 py-2.5  disabled:cursor-not-allowed bg-emerald-600 text-white font-semibold rounded-lg hover:bg-emerald-700 focus:outline-none flex justify-center items-center focus:ring-4 focus:ring-emerald-200 transition-all shadow-sm"
            >
              {fundApproveLoading?.type === "approved" &&
              fundApproveLoading.loadingStatus ? (
                <>
                  <Loader2 className="animate-spin text-light" />
                </>
              ) : (
                "Approve Funds"
              )}
            </button>
          </div>
        </div>
      </FundApprovePopup>
      {/* Fund Request Table */}
      <div className="mt-6 overflow-x-auto ">
        <table className="min-w-full bg-white shadow-md rounded-md">
          <thead className="bg-blue-600 text-white">
            <tr className="">
              {[
                "SN.",
                "User ID",
                "Name",
                "Mobile",
                "Amount",
                "Mode",
                "UTR",
                "Request Date",
                "Slip",
                "Status",
                "Remarks",
                "Order ID",
              ].map((heading, index) => (
                <th key={index} className="p-2 text-center  whitespace-nowrap">
                  <div className="flex items-center gap-2 justify-center">
                    {heading === "Slip" && <Eye size={20} />} {heading}
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {fundRequestReport.length > 0 ? (
              fundRequestReport.map((fund, index) => (
                <tr
                  key={fund.id}
                  className={`hover:bg-gray-50 ${fund?.status?.value === "failed" ? "bg-red-100" : fund?.status?.value === "approved" ? "bg-green-100" : fund?.status?.value === "pending" ? "bg-yellow-100" : null}`}
                >
                  <td className="p-2 whitespace-nowrap text-sm font-medium text-gray-900 border border-gray-300 text-center">
                    {(currentPage - 1) * totaldata + index + 1}
                  </td>
                  <td className="p-2 whitespace-nowrap text-sm font-medium text-gray-900 border border-gray-300 text-center">
                    {fund?.user?.user_id}
                  </td>
                  <td className="p-2 whitespace-nowrap text-sm font-medium text-gray-900 border border-gray-300 text-center">
                    <span className="font-semibold"> {fund?.user?.name} </span>
                  </td>
                  <td className="p-2 whitespace-nowrap text-sm font-medium text-gray-900 border border-gray-300 text-center">
                    {fund?.user?.mobile_number}
                  </td>

                  <td
                    className={`p-2 whitespace-nowrap text-sm font-medium border border-gray-300 text-center ${
                      fund?.status?.value === "pending"
                        ? "text-yellow-600"
                        : fund?.status?.value === "rejected"
                          ? "text-red-600"
                          : "text-green-600"
                    }`}
                  >
                    ₹{fund?.amount}
                  </td>

                  <td className="p-2 whitespace-nowrap text-sm font-medium text-gray-900 border border-gray-300 text-center">
                    {fund?.mode === "online"
                      ? "Bank Transfer"
                      : fund?.mode === "qr"
                        ? "UPI"
                        : "-"}
                  </td>
                  <td className="p-2 whitespace-nowrap text-sm font-medium text-gray-900 border border-gray-300 text-center">
                    {fund?.transaction_ids?.[0]?.utr || "-"}
                  </td>
                  <td className="p-2 whitespace-nowrap text-sm font-medium bg-white text-gray-900 border border-gray-300 text-center">
                    {new Date(fund?.created_at)?.toLocaleString()}
                  </td>
                  <td className="p-2 whitespace-nowrap text-sm font-medium text-gray-900 border border-gray-300 text-center">
                    <button
                      onClick={() => {
                        setShowSlip(fund?.mode);
                        setPaymentStatus(fund?.status?.value);
                        setFileName(fund?.pay_slip?.[0]?.file);
                        setSlipdetailsForUpi(fund?.qr_payment);
                      }}
                      className=" rounded-md px-3 py-1 hover:bg-blue-200 transition"
                    >
                      <img
                        className={
                          fund?.mode === "online" ? "w-6 h-auto" : "w-16 h-auto"
                        }
                        src={
                          fund?.mode === "online"
                            ? "https://cdn-icons-png.flaticon.com/128/10436/10436288.png"
                            : "https://upload.wikimedia.org/wikipedia/commons/6/6f/UPI_logo.svg"
                        }
                        alt="bank and upi"
                      />
                    </button>
                  </td>
                  {/* <td className="p-2 whitespace-nowrap border border-gray-300 text-center">
                    {fund?.status?.value === "pending" ? (
                      <button
                        className="bg-blue-500 text-white rounded-md px-3 py-1 hover:bg-blue-600 transition"
                        onClick={() => {
                          setSelectedName(fund?.user?.name);
                          setSelectedUserId(fund?.user?.user_id);
                          setAmount(fund?.amount);
                          setFileName(fund?.pay_slip?.[0]?.file);
                          setSelectedFundId(fund?.id);
                          setApprovePopUp(true);
                        }}
                      >
                        Update
                      </button>
                    ) : (
                      <span
                        className={`px-3 py-1 rounded text-white text-sm ${
                          fund?.status?.value === "rejected" ||
                          fund?.status?.value === "failed"
                            ? "bg-red-600"
                            : "bg-green-600"
                        }`}
                      >
                        {fund?.status?.value}
                      </span>
                    )}
                  </td> */}

                  <td
                    className={`p-2 whitespace-nowrap text-sm font-bold border border-gray-300 text-center uppercase ${
                      fund?.status?.value === "pending"
                        ? "text-yellow-600"
                        : fund?.status?.value === "rejected" ||
                            fund?.status?.value === "failed"
                          ? "text-red-600"
                          : "text-green-600"
                    }`}
                  >
                    {fund?.status?.value}
                  </td>
                  <td className="p-2 whitespace-nowrap text-xs font-medium text-gray-900 border border-gray-300 text-center">
                    {fund?.remarks || "-"}
                  </td>

                  <td className="p-2 whitespace-nowrap text-xs font-medium text-gray-900 border border-gray-300 text-center">
                    {fund?.transaction_ids?.[0]?.order_id || "-"}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="11" className="p-8 text-center">
                  <div className="flex flex-col items-center justify-center text-gray-500">
                    <FaInbox className="text-5xl mb-2" />
                    <p className="text-xl">No Data Found</p>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <PaymentSlipModal
        status={paymentStatus}
        paymentData={slipDetailsForUpi}
        isOpen={showSlip === "qr"}
        onClose={() => setShowSlip("none")}
      />

      <ImageSlipModal
        fileUrl={paySlip}
        imgPreviewLoading={isImagePreview}
        isOpen={showSlip === "online"}
        onClose={() => setShowSlip("none")}
      />

      {/* Pagination Controls */}
      {paginationData?.total > 0 && (
        <div className="mt-6 flex flex-col sm:flex-row justify-between items-center gap-4">
          <div className="text-sm text-gray-600">
            Page {currentPage} of {paginationData?.last_page || 1}
          </div>

          <div className="flex gap-2 flex-wrap justify-center">
            <button
              onClick={handlePreviousPage}
              disabled={currentPage === 1}
              className={`px-4 py-2 rounded-md ${
                currentPage === 1
                  ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                  : "bg-blue-900 text-white hover:bg-blue-800"
              }`}
            >
              Previous
            </button>

            {generatePageNumbers().map((pageNum, index) => (
              <button
                key={index}
                onClick={() =>
                  typeof pageNum === "number" && handlePageClick(pageNum)
                }
                disabled={pageNum === "..."}
                className={`px-3 py-2 rounded-md ${
                  pageNum === currentPage
                    ? "bg-blue-900 text-white"
                    : pageNum === "..."
                      ? "bg-white text-gray-500 cursor-default"
                      : "bg-white text-gray-700 border border-gray-300 hover:bg-gray-100"
                }`}
              >
                {pageNum}
              </button>
            ))}

            <button
              onClick={handleNextPage}
              disabled={!paginationData?.next_page_url}
              className={`px-4 py-2 rounded-md ${
                !paginationData?.next_page_url
                  ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                  : "bg-blue-900 text-white hover:bg-blue-800"
              }`}
            >
              Next
            </button>
          </div>
        </div>
      )}

      {imagePreviewClicked && (
        <div
          className="fixed inset-0 z-[999] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4"
          onClick={() => setImagePreviewClicked(false)}
        >
          <div
            className="relative w-full max-w-lg max-h-[90vh] bg-white rounded-2xl shadow-2xl overflow-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setImagePreviewClicked(false)}
              className="sticky top-2 ml-auto mr-2 mt-2 flex h-10 w-10 items-center justify-center rounded-full bg-white shadow-md hover:bg-gray-100 z-10"
            >
              <X size={20} />
            </button>

            <div className="p-4 flex justify-center">
              <img
                src={paySlip}
                alt="Payment Slip"
                className="max-w-full h-auto object-contain"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FundApprove2;
